import overview1 from "../../assets/img/43-0-0-0-10000-10000-500.jpg";
import overview2 from "../../assets/img/99-0-0-0-10000-10000-500.jpg";
import overview3 from "../../assets/img/92-0-0-0-10000-10000-500.jpg";
import overview4 from "../../assets/img/161-0-0-0-10000-10000-500.jpg";
import overview5 from "../../assets/img/170-0-0-0-10000-10000-500.jpg";
import overview6 from "../../assets/img/200-0-0-1695-10000-8305-500.jpg";
import overview7 from "../../assets/img/188-0-0-0-10000-10000-500.jpg";

import pr1 from "../../assets/img/51-0-0-0-10000-10000-412.jpg";
import pr2 from "../../assets/img/100-0-0-0-10000-10000-412.jpg";
import pr3 from "../../assets/img/51-0-0-0-10000-10000-412.jpg";
import pr4 from "../../assets/img/162-0-0-0-10000-10000-412.jpg";
import pr5 from "../../assets/img/170-0-0-0-10000-10000-412.jpg";
import pr6 from "../../assets/img/201-0-207-1941-9793-8059-412.jpg";
import pr7 from "../../assets/img/172-0-0-0-10000-10000-412.jpg";

const ServiceCarts = () => {
  return (
    <>
      <section className="serviceSection sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="fisherman-content">
                <strong>Part Number: NBNT-2</strong>
                <h4>2-Bottle Easy-load Nitrogen Service Cart </h4>
                <p>
                  The 2-bottle easy-load nitrogen service cart is compliant with
                  Occupational Health & Safety (OH&S) requirements allowing a
                  single person to safely load and off-load gas cylinders.
                </p>
                <p>
                  The calibrated and colour coded dual use, low & high pressure
                  nitrogen charging system allows inflation tasks to be
                  undertaken safely and efficiently whilst the auto-retract hose
                  reels allow the operator flexibility around any aircraft.
                </p>
                <p>
                  The nitrogen cart also features an articulating front axle
                  which can pivot independent to the main chassis offering added
                  durability, safety and added stability when being towed.
                </p>
                <p>
                  This product is ideal for base and line maintenance activities
                  and can be used on a wide range of aircraft series including:
                  Airbus, Antanov, BAE Systems, Boeing, Bombardier, Comac,
                  Dassault, Embraer, Gulfstream, Irkut, Lockheed, Mitsubishi,
                  Pilatus, Sukhoi, Tupolev, Textron
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="overviewFigure">
                <img src={overview1} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-lg-4">
                <div className="fisherman-content">
                  <h4>Advantages </h4>
                  <ul>
                    <li>Single Person Use </li>
                    <li>Low & High Pressure Configuration </li>
                    <li>Calibrated Pressure Gauges </li>
                    <li>Self-Venting Pressure Regulator System </li>
                    <li>Safety Pressure Relief Valves </li>
                    <li>2 x Auto-Retract Reels Each With 9 Meter Hose </li>
                    <li>Released With Calibration & Warranty </li>
                    <li>BSEN, P.E.D & CE Compliant</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="fisherman-content">
                  <h4>Options </h4>
                  <ul>
                    <li>Full Customization Can Be Offered </li>
                    <li>Gas Booster (Intensifier) </li>
                    <li>Different Size Towing Eye </li>
                    <li>Country Compatible Gas Cylinder Connections </li>
                    <li>Customer Specific Paint Colour </li>
                    <li>Gas Cylinder Re-Fill Port </li>
                    <li>Foam-Filled Tyres </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="overviewFigure">
                  <img src={pr1} alt="Overview" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="serviceSection sectionPD bgGray">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="overviewFigure">
                <img src={overview2} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="fisherman-content">
                <strong>Part Number: NBOT-2 </strong>
                <h4>2-Bottle Easy-Load Oxygen Service Cart </h4>
                <p>
                  The 2-bottle easy-load oxygen service cart is compliant with
                  Occupational Health & Safety (OH&S) requirements allowing a
                  single person to safely load and off-load gas cylinders.
                </p>
                <p>
                  The calibrated high pressure oxygen charging system allows
                  oxygen replenishment tasks to be undertaken safely and
                  efficiently whilst the auto-retract hose reels allow the
                  operator flexibility around any aircraft.
                </p>
                <p>
                  The oxygen cart also features an articulating front axle which
                  can pivot independent to the main chassis offering added
                  durability, safety and added stability when being towed.
                </p>
                <p>
                  This product is ideal for base and line maintenance activities
                  and can be used on a wide range of aircraft series including:
                  Airbus, Antanov, BAE Systems, Boeing, Bombardier, Comac,
                  Dassault, Embraer, Gulfstream, Irkut, Lockheed, Mitsubishi,
                  Pilatus, Sukhoi, Tupolev, Textron
                </p>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-lg-4">
                <div className="overviewFigure">
                  <img src={pr2} alt="Overview" className="img-fluid" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="fisherman-content">
                  <h4>Advantages </h4>
                  <ul>
                    <li>Single Person Use </li>
                    <li>High Pressure System </li>
                    <li>Calibrated Pressure Gauges </li>
                    <li>Self-Venting Pressure Regulator System </li>
                    <li>Safety Pressure Relief Valves </li>
                    <li>2 x Auto-Retract Reels Each With 9 Meter Hose </li>
                    <li>Released With Calibration & Warranty </li>
                    <li>BSEN, P.E.D & CE Compliant</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="fisherman-content">
                  <h4>Options </h4>
                  <ul>
                    <li>Full Customization Can Be Offered </li>
                    <li>Gas Booster (Intensifier) </li>
                    <li>Different Size Towing Eye </li>
                    <li>Country Compatible Gas Cylinder Connections </li>
                    <li>Customer Specific Paint Colour </li>
                    <li>Gas Cylinder Re-Fill Port </li>
                    <li>Foam-Filled Tyres </li>
                    <li>Powder Fire Extinguisher </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="serviceSection sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="fisherman-content">
                <strong>Part Number: NBNT- 70482</strong>
                <h4>2-Bottle Flat Bed Nitrogen Service Cart </h4>
                <p>
                  The 2-bottle Flat-bed nitrogen service cart offers safe
                  stowage of 2 x gas cylinders in a secure horizontal fixed
                  position.
                </p>
                <p>
                  The calibrated and colour coded dual use, low & high pressure
                  charging system allows inflation tasks to be undertaken safely
                  and efficiently whilst the auto-retract hose reels allow the
                  operator flexibility around any aircraft.
                </p>
                <p>
                  This product is ideal for base and line maintenance activities
                  and can be used on a wide range of aircraft series including:
                  Airbus, Antanov, BAE Systems, Boeing, Bombardier, Comac,
                  Dassault, Embraer, Gulfstream, Irkut, Lockheed, Mitsubishi,
                  Pilatus, Sukhoi, Tupolev, Textron
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="overviewFigure">
                <img src={overview3} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-lg-4">
                <div className="fisherman-content">
                  <h4>Advantages </h4>
                  <ul>
                    <li>Single Person Use </li>
                    <li>Low & High Pressure Configuration </li>
                    <li>Calibrated Pressure Gauges </li>
                    <li>Self-Venting Pressure Regulator System </li>
                    <li>Safety Pressure Relief Valves </li>
                    <li>2 x Auto-Retract Reels Each With 9 Meter Hose </li>
                    <li>Released With Calibration & Warranty </li>
                    <li>BSEN, P.E.D & CE Compliant</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="fisherman-content">
                  <h4>Options </h4>
                  <ul>
                    <li>Full Customization Can Be Offered </li>
                    <li>Gas Booster (Intensifier) </li>
                    <li>Different Size Towing Eye </li>
                    <li>Country Compatible Gas Cylinder Connections </li>
                    <li>Customer Specific Paint Colour </li>
                    <li>Gas Cylinder Re-Fill Port </li>
                    <li>Foam-Filled Tyres </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="overviewFigure">
                  <img src={pr3} alt="Overview" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="serviceSection sectionPD bgGray">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="overviewFigure">
                <img src={overview4} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="fisherman-content">
                <strong>Part Number: NBOT - 70485 </strong>
                <h4>2-Bottle Flat Bed Oxygen Service Cart </h4>
                <p>
                  The 2-bottle Flat-bed oxygen service cart offers safe stowage
                  of 2 x gas cylinders in a secure horizontal fixed position.
                </p>
                <p>
                  The calibrated high pressure charging system allows oxygen
                  inflation tasks to be undertaken safely and efficiently whilst
                  the auto-retract hose reel allows the operator flexibility
                  around any aircraft.
                </p>
                <p>
                  Equipped with an auto-self venting pressure setting regulator,
                  pressure relief valve, and gas inlet heat soak stems, the
                  oxygen compliant system offers the user the highest of safety
                  standards.
                </p>
                <p>
                  This product is ideal for base and line maintenance activities
                  and can be used on a wide range of aircraft series including:
                  Airbus, Antanov, BAE Systems, Boeing, Bombardier, Comac,
                  Dassault, Embraer, Gulfstream, Irkut, Lockheed, Mitsubishi,
                  Pilatus, Sukhoi, Tupolev, Textron
                </p>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-lg-4">
                <div className="overviewFigure">
                  <img src={pr4} alt="Overview" className="img-fluid" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="fisherman-content">
                  <h4>Advantages </h4>
                  <ul>
                    <li>Single Person Use </li>
                    <li>Low & High Pressure System </li>
                    <li>Calibrated Pressure Gauges </li>
                    <li>Self-Venting Pressure Regulator System </li>
                    <li>Safety Pressure Relief Valves </li>
                    <li>2 x Auto-Retract Reels Each With 9 Meter Hose </li>
                    <li>Released With Calibration & Warranty </li>
                    <li>BSEN, P.E.D & CE Compliant</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="fisherman-content">
                  <h4>Options </h4>
                  <ul>
                    <li>Full Customization Can Be Offered </li>
                    <li>Gas Booster (Intensifier) </li>
                    <li>Different Size Towing Eye </li>
                    <li>Country Compatible Gas Cylinder Connections </li>
                    <li>Customer Specific Paint Colour </li>
                    <li>Gas Cylinder Re-Fill Port </li>
                    <li>Foam-Filled Tyres </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="serviceSection sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="fisherman-content">
                <strong>Part Number: NBWBCT-002OT </strong>
                <h4>Universal Wheel & Brake Change Trailer - Open Roof </h4>
                <p>
                  The Newbow Aerospace manufactured aircraft wheel and brake
                  change trailers have been primarily designed to support fast,
                  safe and effective wheel and brake change operations on the
                  ramp, around the airport and even within the hangar.
                </p>
                <p>
                  Designed to accommodate four aircraft wheels, one wheel and
                  brake change dolly, one axle jack and a multitude of aircraft
                  tooling, the Newbow Aerospace wheel and brake change trailer
                  is the ultimate aviation mobile service support centre.
                </p>
                <p>
                  The trailer can accommodate a payload of 1000 KG+ and can be
                  accessed via the aluminium spring balanced rear door allowing
                  for one person to easily load and off-load the contents.
                </p>
                <p>
                  This product is ideal for base and line maintenance activities
                  and can be used on a wide range of aircraft series including:
                  Airbus, Antanov, BAE Systems, Boeing, Bombardier, Comac,
                  Dassault, Embraer, Gulfstream, Irkut, Lockheed, Mitsubishi,
                  Pilatus, Sukhoi, Tupolev, Textron
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="overviewFigure">
                <img src={overview5} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-lg-4">
                <div className="fisherman-content">
                  <h4>Advantages </h4>
                  <ul>
                    <li>Single Person Use </li>
                    <li>Easy to Manoeuvre and Handle </li>
                    <li>Aluminium Rear Ramp Door </li>
                    <li>Compact Design </li>
                    <li>
                      Double Acting Parking Brake (Auto- activate + Manual
                      Activate){" "}
                    </li>
                    <li>Integrated tow arm with lift & lock parking brake </li>
                    <li>Suitable for all aircraft type </li>
                    <li>BSEN, P.E.D & CE Compliant </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="fisherman-content">
                  <h4>Options </h4>
                  <ul>
                    <li> Full Customization Can Be Offered </li>
                    <li>Different Size Towing Eye </li>
                    <li>Customer Specific Paint Colour </li>
                    <li>Customer Corporate Logo Fitted </li>
                    <li>Foam-Filled Tyres </li>
                    <li>Gas Bottle Storage System </li>
                    <li>Nitrogen System or Regulator System </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="overviewFigure">
                  <img src={pr5} alt="Overview" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="serviceSection sectionPD bgGray">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="overviewFigure">
                <img src={overview6} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="fisherman-content">
                <strong>Part Number: NBWTA500 </strong>
                <h4>Universal Wheel & Brake Change Dolly </h4>
                <p>
                  The universal aircraft wheel & brake change dolly has been
                  specifically designed for the safe removal and replacement of
                  aircraft wheels and brake pack units.
                </p>
                <p>
                  Equipped with swivelling and braked castor wheels and
                  ergonomic handles, the unit is extremely manoeuvrable allowing
                  great flexibility around aircraft landing gear.
                </p>
                <p>
                  The hydraulic hand-pump allows easy lifting of aircraft wheels
                  of which can then be rotated into position by provision of the
                  lifting rollers.
                </p>
                <p>
                  The lifting rollers are fully adjustable allowing for
                  multi-positioning to suit the aircraft wheel size.
                </p>
                <p>
                  A wheel restraint bar is stowed within the wheel dolly frame
                  and allows full adjustment to meet the wheel size that is
                  being handled. A separate telescopic brake lifting arm is also
                  available to support brake change tasks.{" "}
                </p>
                <p>
                  A safe and efficient solution for assisting wheel and brake
                  change tasks.{" "}
                </p>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-lg-4">
                <div className="overviewFigure">
                  <img src={pr6} alt="Overview" className="img-fluid" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="fisherman-content">
                  <h4>Advantages </h4>
                  <ul>
                    <li>Single Person Use </li>
                    <li>Hydraulic Lift & Lower </li>
                    <li>Flexibility Around Aircraft </li>
                    <li>Heavy-Duty & Robust </li>
                    <li>Swivelling & Braked Castor Wheels</li>
                    <li>Integrated Wheel Restraint </li>
                    <li>Powder-Coat Finish </li>
                    <li>500 KG Safe Working Load</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="fisherman-content">
                  <h4>Options </h4>
                  <ul>
                    <li> Customer Specific Paint Colour </li>
                    <li>Full Customization Can Be Offered </li>
                    <li>Telescopic Brake Lifting Arm </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="serviceSection sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="fisherman-content">
                <strong> Part Number: NBWBCT-N2 </strong>
                <h4>
                  Universal Wheel & Brake Change Trailer - Fully Enclosed{" "}
                </h4>
                <p>
                  The Newbow Aerospace manufactured aircraft wheel and brake
                  change trailers have been primarily designed to support fast,
                  safe and effective wheel and brake change operations on the
                  ramp, around the airport and even within the hangar.{" "}
                </p>

                <p>
                  Designed to accommodate four aircraft wheels, one wheel and
                  brake change dolly, one axle jack and a multitude of aircraft
                  tooling, the Newbow Aerospace wheel and brake change trailer
                  is the ultimate aviation mobile service support centre.{" "}
                </p>

                <p>
                  The trailer can accommodate a payload of 1000 KG+ and can be
                  accessed via the aluminium spring balanced rear door that
                  offers minimal gradient, allowing for one person to easily
                  load and off-load the contents.{" "}
                </p>
                <p>
                  For optimum efficiency during aircraft turnaround and
                  maintenance cycles, this specific trailer is offered with a
                  fully certified nitrogen charging system.{" "}
                </p>

                <p>
                  The calibrated nitrogen-charging panel, two x auto retractable
                  hose reels and two cylinder stowage points are externally
                  mounted at the front of the trailer for ease of access and
                  usage.
                </p>
                <p>
                  This variant allows operators to undertake the required wheel
                  and brake change operation and nitrogen inflation tasks from a
                  single source, minimising operator travel time and the need
                  for multiple carts to be used.
                </p>
                <p>
                  This product is ideal for base and line maintenance activities
                  and can be used on a wide range of aircraft series including:
                  Airbus, Antanov, BAE Systems, Boeing, Bombardier, Comac,
                  Dassault, Embraer, Gulfstream, Irkut, Lockheed, Mitsubishi,
                  Pilatus, Sukhoi, Tupolev, Textron
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="overviewFigure">
                <img src={overview7} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-lg-4">
                <div className="fisherman-content">
                  <h4>Advantages </h4>
                  <ul>
                    <li>Single Person Use </li>
                    <li>On-Board LP & HP Nitrogen System  </li>
                    <li>Easy to Manoeuvre and Handle </li>
                    <li>Aluminium Rear Ramp Door </li>
                    <li>UV Opaque Roof For Daylight Penetration  </li>
                    <li>
                      Double Acting Parking Brake (Auto- activate + Manual Activate) 
                    </li>
                    <li>Integrated tow arm with lift & lock parking brake </li>
                    <li>Suitable for all aircraft type </li>
                    <li>BSEN, P.E.D & CE Compliant </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="fisherman-content">
                  <h4>Options </h4>
                  <ul>
                    <li> Full Customization Can Be Offered </li>
                    <li>Different Size Towing Eye </li>
                    <li>Customer Specific Paint Colour </li>
                    <li>Customer Corporate Logo Fitted </li>
                    <li>Foam-Filled Tyres </li>
                    <li>Gas Bottle Storage System </li>
                    <li>Nitrogen System or Regulator System </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="overviewFigure">
                  <img src={pr7} alt="Overview" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServiceCarts;
